import { useBreakpoints as _useBreakpoints } from '@vueuse/core'
import { useMenuToggles } from '@/composables/layouts/useMenuToggles'
import { computed } from 'vue'

const bulmaBreakpoints = {
  mobile: 768,
  tablet: 769,
  desktop: 1024,
  widescreen: 1216,
  fullhd: 1408,
}

export function useBreakpoints() {
  const { showLeftNav } = useMenuToggles()
  // https://bulma.io/documentation/start/responsiveness/
  const breakpoints = _useBreakpoints(bulmaBreakpoints)
  const isMobile = breakpoints.smallerOrEqual('mobile')
  const isSmallScreen = breakpoints.smallerOrEqual('mobile')
  const isTabletScreen = breakpoints.smallerOrEqual('tablet')
  const smallerThanTablet = breakpoints.smaller('tablet')
  const greaterThanTablet = breakpoints.greater('tablet')
  const smallerThanDesktop = breakpoints.smaller('desktop')
  const greaterThanDesktop = breakpoints.greater('desktop')
  const greaterThanWidescreen = breakpoints.greater('widescreen')
  const greaterThanFullhd = breakpoints.greater('fullhd')

  // LEGACY
  const isTabletLargeView = computed(
    () => isTabletScreen.value && showLeftNav.value === false,
  )
  const isDesktopLargeView = computed(
    () =>
      greaterThanWidescreen.value ||
      (greaterThanDesktop.value && showLeftNav.value === false),
  )

  return {
    breakpoints,
    isMobile,
    isSmallScreen,
    isTabletScreen,
    smallerThanDesktop,
    smallerThanTablet,
    greaterThanTablet,
    greaterThanWidescreen,
    greaterThanFullhd,
    // LEGACY
    isTouch: isMobile,
    isMobileView: isMobile,
    isTabletView: isTabletScreen,
    isDesktopView: greaterThanTablet,
    isWidescreenView: greaterThanDesktop,
    isTabletLargeView,
    isDesktopLargeView,
  }
}
